export class ApiCommonModuleOptions {
  serverURL: string
}